<template>
    <v-container fluid style="padding: 0px;">
        <v-card class="mx-auto pa-5" :max-width="$vuetify.breakpoint.smAndDown ? 900 : 800" outlined
            style="background: #F7F5F5; border-radius: 30px; border: 2px solid #05435B ;">
            <v-row v-if="$vuetify.breakpoint.mobile">
                <v-spacer></v-spacer>
                <v-col cols="4">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab dark small color="#05435B" v-bind="attrs" v-on="on"
                                @click="updateSmartLab">
                                <v-icon dark>mdi-file-document-refresh-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Actualizar Archivo SmartLab</span>
                    </v-tooltip>

                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <span class="font-weight-black text-h7 mr-5">
                        Área:
                    </span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 3">
                    <v-select :items="items" v-model="ubicacion" density="compact" dense outlined
                        style="height: 35px;"></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <span v-if="fileSmartLab.length > 0" class="font-weight-black text-h7 mr-5">
                        Archivo SmartLab disponible:
                    </span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 5">
                    <a v-if="fileSmartLab.length > 0" href="#" @click.prevent="getFileSmartLab()" target="_blank"
                        class="text-h7 mr-5 text-primary text-decoration-underline">
                        {{ ubicacion == 'Flota' ? getInfoFile(1) : getInfoFile(2) }}
                    </a>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="1">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab dark small color="#05435B" v-bind="attrs" v-on="on"
                                @click="updateSmartLab">
                                <v-icon dark>mdi-file-document-refresh-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Actualizar Archivo SmartLab</span>
                    </v-tooltip>

                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <span class="font-weight-black text-h7 mr-5">Archivo Centralizado</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="Centralizado.xlsx" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(0, $event)" show-size></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="Centralizado.xlsx" label="Archivo Centralizado" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(0, $event)" show-size></v-file-input>
                </v-col>
            </v-row>
            <v-row v-if="!$vuetify.breakpoint.mobile">
                <v-col cols="6" style="display:flex">
                    <span class="font-weight-black text-h7 mr-5">Archivo SmartLab</span>
                </v-col>
                <v-col cols="6" style="display:flex; align-items: center;">
                    <v-file-input v-if="switchSmartLab" placeholder="SmartLab.xlsx" clearable dense outlined
                        style="height: 35px; ; margin-right: 10px;" accept=".xls,.xlsx" @change="updateFile(1, $event)"
                        show-size></v-file-input>
                    <v-switch v-model="switchSmartLab" :label="switchSmartLab ? 'Sí' : 'No'" hide-details
                        @change="changeFormato()" color="#05435B" inset></v-switch>
                </v-col>

            </v-row>
            <v-row v-if="$vuetify.breakpoint.mobile">
                <v-col v-if="!switchSmartLab" cols="6" style="display:flex">
                    <span class="font-weight-black text-h7 mr-5">Archivo SmartLab</span>
                </v-col>
                <v-col :cols="switchSmartLab?12:6" style="display:flex; align-items: center;">
                    <v-file-input v-if="switchSmartLab" placeholder="SmartLab.xlsx" clearable dense outlined
                        style="height: 35px; ; margin-right: 10px;" accept=".xls,.xlsx" @change="updateFile(1, $event)"
                        show-size></v-file-input>
                    <v-switch v-model="switchSmartLab" :label="switchSmartLab ? 'Sí' : 'No'" hide-details
                        @change="changeFormato()" color="#05435B" inset></v-switch>
                </v-col>

            </v-row>
            <v-row :style="{ marginTop: '0px', marginBottom: $vuetify.breakpoint.smAndDown ? '10px' : '0px' }">
                <v-col cols="12" style="display: flex; justify-content: center; padding-top: 0px;">
                    <v-btn color="success" class="mt-4 rounded-button" @click="evaluar()">
                        Procesar
                    </v-btn>
                </v-col>
            </v-row>
            <v-row style="margin-top: 0px;margin-bottom: 10px;" v-if="archivosGenerados.length > 0">
                <v-spacer></v-spacer>
                <!-- Iterar sobre archivosGenerados -->
                <v-col v-for="(archivo, index) in archivosGenerados" :key="archivo.id" cols="12"
                    class="d-flex align-center" style="height: 40px;">
                    <!-- Mostrar nombre del archivo -->
                    <v-spacer></v-spacer>
                    <v-col cols="8">
                        <span class="font-weight-black text-h8">{{ archivo.nombreFisico }}</span>
                    </v-col>

                    <!-- Botón para descargar -->
                    <v-col cols="2" class="text-right">
                        <v-btn density="compact" @click="descargar(archivo.id, archivo.nombreFisico)">
                            <v-icon style="color:#04395a">mdi-file-download-outline</v-icon>
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService';

export default {
    data() {
        return {
            fromDateMenu1: false, // Controla el menú de la fecha "Desde"
            fromDateMenu2: false, // Controla el menú de la fecha "Hasta"
            fechaDesde: null, // Fecha seleccionada para "Desde"
            fechaHasta: null, // Fecha seleccionada para "Hasta"
            borradoPedido: true,
            valid: false,
            files: [null], // Archivos: [ODM, SOLPEDS, AVANCE INICIAL]
            archivosGenerados: [],
            fileSmartLab: [],
            switchSmartLab: false,
            items: ['Flota', 'Planta'],
            ubicacion: 'Flota'
        };
    },
    computed: {
        formattedDesde() {
            return this.fechaDesde
                ? new Date(this.fechaDesde + 'T00:00:00').toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                : "";
        },
        formattedHasta() {
            return this.fechaHasta
                ? new Date(this.fechaHasta + 'T00:00:00').toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                : "";
        },
    },
    created() {
        this.getSmartLab();
    },
    methods: {
        validateFechaDesde(value) {
            if (this.fechaHasta && new Date(value) > new Date(this.fechaHasta)) {
                this.fechaDesde = null;
                alert("La fecha de inicio no puede ser mayor que la fecha de fin.");
            } else {
                this.fechaDesde = value;
            }
            this.fromDateMenu1 = false;
        },
        validateFechaHasta(value) {
            if (this.fechaDesde && new Date(value) < new Date(this.fechaDesde)) {
                this.fechaHasta = null;
                alert("La fecha de fin no puede ser menor que la fecha de inicio.");
            } else {
                this.fechaHasta = value;
            }
            this.fromDateMenu2 = false;
        },
        updateFile(index, file) {
            // Actualiza el archivo correspondiente en el arreglo `files`
            this.files[index] = file;
        },
        isExcelFile(file) {
            // Verifica si el archivo tiene extensión válida
            const allowedExtensions = [".xls", ".xlsx"];
            const fileName = file.name.toLowerCase();
            return allowedExtensions.some(ext => fileName.endsWith(ext));
        },

        async evaluar() {
            this.archivosGenerados = [];
            try {
                SwalService.loading('Procesando...', 'Por favor espere.');
                if (!this.files.every(file => file !== null)) {
                    SwalService.close();
                    await new Promise(resolve => setTimeout(resolve, 100));
                    await SwalService.alert('Debe cargar todos los campos para poder continuar')
                    return;
                }
                // Realizar solicitud POST al backend para autenticación
                const response = await apiService.post("/programa-trabajos/inicia-proceso", {
                    indicadorBorrado: this.borradoPedido,
                    idProceso: null,
                    tipoProceso: this.switchSmartLab ? (this.ubicacion == 'Flota' ? 9 : 10) : (this.ubicacion == 'Flota' ? 11 : 12),
                    idUsuario: 2
                });

                // Maneja la respuesta
                const respuesta = response.data;
                if (respuesta.success) {
                    let datos = {
                        archivos: [
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 24,
                            }


                        ],
                    };

                    // Crear un FormData para enviar los archivos y los datos juntos
                    const formData = new FormData();

                    // Agregar los archivos a FormData (asegurando que los archivos sean seleccionados por el usuario)
                    formData.append("files", this.files[0]);
                    if (this.switchSmartLab) {
                        datos.archivos.push({
                            id: null,
                            nombreLogico: null,
                            nombreFisico: null,
                            ruta: null,
                            fechaCarga: null,
                            proceso: respuesta.proceso,
                            tipoArchivo: 25,
                        },)
                        formData.append("files", this.files[1]);
                    }

                    // Agregar los datos serializados en formato JSON
                    formData.append("datosAdjunto", JSON.stringify(datos.archivos));

                    // Enviar los datos y los archivos al endpoint
                    const response2 = await apiService.post("/files/upload", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });

                    // Manejar la respuesta de la carga de archivos
                    const uploadResponse = response2.data;

                    const response3 = await apiService.post("/programa-trabajos/ejecuta-script", {
                        fechaInicio: this.fechaDesde,
                        fechaFin: this.fechaHasta,
                        indicadorBorrado: this.borradoPedido,
                        idProceso: respuesta.proceso.idProceso,
                        tipoProceso: this.switchSmartLab ? (this.ubicacion == 'Flota' ? 9 : 10) : (this.ubicacion == 'Flota' ? 11 : 12),
                        idUsuario: 2
                    });

                    const ejecutaScript = response3.data;
                    if (ejecutaScript.success) {
                        this.archivosGenerados = ejecutaScript.archivos;
                        SwalService.close();
                        SwalService.success('Evaluación Completada', 'El archivo generado ya se encuentra disponible para descargar');
                    } else {
                        SwalService.close();
                        await new Promise(resolve => setTimeout(resolve, 100));
                        SwalService.error(ejecutaScript.error);
                    }

                } else {
                    SwalService.close();
                }

            } catch (error) {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
                SwalService.error('Error al cargar datos', 'Ocurrió un problema.');
            }
        },
        async descargar(id, fileName) {
            try {
                SwalService.loading('Descargando...', 'Por favor espere.');
                await apiService.downloadFile(`/files/${id}`, fileName);
                console.log('Archivo descargado exitosamente.');
                SwalService.close();
            } catch (error) {
                console.error('Error al descargar el archivo:', error);
                SwalService.close();
                SwalService.success('Simulación Completada', 'El archivo simulado ya se encuentra disponible para descargar');
                SwalService.error('No se pudo descargar el archivo. Intenta nuevamente.');
            }
        },

        async getSmartLab() {
            SwalService.loading('Cargando..', 'Por favor espere.');
            const response = await apiService.get("/programa-trabajos/get-data-smartlab")
            if (response.data.fileList.length > 0) {
                this.fileSmartLab = response.data.fileList;
                this.fileSmartLab = this.fileSmartLab.map(item => ({
                    ...item, // Copia los demás atributos
                    size: this.formatSize(item.size)
                }));
            } else {
                this.fileSmartLab = [];
            }
            SwalService.close();
            await new Promise(resolve => setTimeout(resolve, 100));
        },
        formatSize(bytes) {
            if (!bytes || bytes < 0) return "0 Bytes"; // Maneja casos inválidos

            const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
            const i = Math.floor(Math.log(bytes) / Math.log(1024)); // Encuentra la unidad adecuada
            return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`; // Redondea a 2 decimales
        },
        formatFileInfo(file) {
            if (!file) return '';
            return `${file.formattedLastModified} - ${file.size}`;
        },
        changeFormato() {
            if (this.switchSmartLab) {
                this.files.push(null);
            } else {
                this.files.pop();
            }
        },
        async updateSmartLab() {
            SwalService.loading('Actualizando..', 'Por favor espere.');
            const response = await apiService.get("/programa-trabajos/update-data-smartlab")
            if (response.data.success) {
                const response = await apiService.get("/programa-trabajos/get-data-smartlab")
                if (response.data.fileList.length > 0) {
                    this.fileSmartLab = response.data.fileList;
                    this.fileSmartLab = this.fileSmartLab.map(item => ({
                        ...item, // Copia los demás atributos
                        size: this.formatSize(item.size)
                    }));
                } else {
                    this.fileSmartLab = [];
                }
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
                SwalService.success('Actualización Completa', 'El archivo SmartLab ha sido actualizado');
            } else {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
            }

        },
        async getFileSmartLab() {
            try {
                SwalService.loading('Descargando...', 'Por favor espere.');
                await apiService.downloadFile(`/files/` + (this.ubicacion == 'Flota' ? '0' : '-1'), 'SmartLab.xlsx');
                console.log('Archivo descargado exitosamente.');
                SwalService.close();
            } catch (error) {
                console.error('Error al descargar el archivo:', error);
                SwalService.close();
                SwalService.success('Simulación Completada', 'El archivo simulado ya se encuentra disponible para descargar');
                SwalService.error('No se pudo descargar el archivo. Intenta nuevamente.');
            }
        },
        getInfoFile(tipo) {
            let index = -1;
            if (tipo == 1) {
                index = this.fileSmartLab.findIndex(item => item.name === "archivo_smartlab_flota.xlsx");
            } else {
                index = this.fileSmartLab.findIndex(item => item.name === "archivo_smartlab_planta.xlsx");
            }
            if (index == -1) return '';
            return `${this.fileSmartLab[index].formattedLastModified} - ${this.fileSmartLab[index].size}`;

        }

    },
};
</script>

<style scoped>
.v-menu__content {
    z-index: 9000 !important;
    position: absolute !important;
}

.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}


</style>